import type { ReactNode } from 'react'
import type { ViewStyle } from 'react-native'
import type { AnimatedStyle } from 'react-native-reanimated'
import { Text } from 'react-native'
import Animated from 'react-native-reanimated'

import { colors } from '../../../theme'
import { body2, headline2 } from '../../../theme/typography'

export function PurchaseScreenCard({
  bottomPadding = 32,
  cardAnimatedStyle,
  children,
  description,
  headline,
  isCompactLayout = false,
  onLayout,
}: {
  bottomPadding?: number
  cardAnimatedStyle: AnimatedStyle<ViewStyle>
  children: ReactNode
  description: string
  headline: string
  isCompactLayout?: boolean
  onLayout: (height: number) => void
}) {
  return (
    <Animated.View
      className={`bg-background-primary -mt-6 rounded-t-[32px] px-6 ${isCompactLayout ? 'pt-4' : 'pt-8'}`}
      style={[cardAnimatedStyle, { paddingBottom: bottomPadding }]}
      onLayout={(event) => {
        const nextHeight = Math.round(event.nativeEvent.layout.height)
        onLayout(nextHeight)
      }}
    >
      <Text
        className={isCompactLayout ? 'mb-2' : 'mb-4'}
        style={[headline2, { color: colors.ink }]}
      >
        {headline}
      </Text>
      <Text
        className={isCompactLayout ? 'mb-5' : 'mb-8'}
        style={[body2, { color: colors.inkSecondary }]}
      >
        {description}
      </Text>
      {children}
    </Animated.View>
  )
}
